import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
	CalendarIcon,
	EyeIcon,
	TrendingUpIcon,
	TrendingDownIcon,
	ChevronRightIcon } from '@heroicons/react/outline'

const DAYS = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
const MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.']

class ActivityWeekCard extends Component {
	_formatTime = (timestamp) => {
		const date = new Date(timestamp * 1000)
		let hours = date.getHours()
		let minutes = date.getMinutes()
		if (hours < 10)
			hours = '0' + hours
		if (minutes < 10)
			minutes = '0' + minutes
		return hours + 'h' + minutes
	}

	_renderDateBadge = (timestamp) => {
		const date = new Date(timestamp * 1000)
		return (
			<div className="w-12 flex flex-col items-center justify-center bg-slate-100 rounded-xl py-1.5 flex-shrink-0">
				<span className="text-3xs font-black uppercase tracking-wider text-slate-400 leading-none">{DAYS[date.getDay()]}</span>
				<span className="text-base font-black text-slate-900 leading-tight">{date.getDate()}</span>
				<span className="text-3xs font-bold text-slate-400 leading-none">{MONTHS[date.getMonth()]}</span>
			</div>
		)
	}

	// Pastille de variation des consultations vs semaine précédente
	_renderViewsDelta = () => {
		const delta = this.props.viewsDeltaPct
		if (delta === null || delta === undefined)
			return null
		const pct = Math.round(delta * 100)
		const up = pct >= 0
		return (
			<span className={"inline-flex items-center gap-0.5 text-2xs font-black px-1.5 py-0.5 rounded-full align-middle ml-1.5 " + (up ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700")}>
				{up
					? <TrendingUpIcon className="w-3 h-3" aria-hidden="true" />
					: <TrendingDownIcon className="w-3 h-3" aria-hidden="true" />}
				{(up ? '+' : '') + pct}%
			</span>
		)
	}

	// Ligne "Programme consulté X fois cette semaine" (engagement planning)
	_renderViews = () => {
		const views = this.props.views7d
		if (views === null || views === undefined)
			return null
		return (
			<div className="flex items-center gap-2 px-5 pb-3">
				<EyeIcon className="w-4 h-4 text-slate-400 flex-shrink-0" aria-hidden="true" />
				<p className="text-xs font-semibold text-slate-500 my-0">
					Programme consulté <span className="font-black text-slate-800">{views}</span> fois cette semaine
					{this._renderViewsDelta()}
				</p>
			</div>
		)
	}

	_renderGauge = (item) => {
		if (this.props.premium !== true || item.capacity === null || item.capacity === 0)
			return null
		const ratio = Math.min(item.registered / item.capacity, 1)
		const full = item.registered >= item.capacity
		const low = !full && ratio < 0.3
		let barColor = 'bg-indigo-500'
		if (full)
			barColor = 'bg-emerald-500'
		else if (low)
			barColor = 'bg-amber-500'
		return (
			<div className="mt-1.5 flex items-center gap-2">
				<div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
					<div className={'h-1.5 rounded-full ' + barColor} style={{ width: Math.round(ratio * 100) + '%' }}></div>
				</div>
				<span className="text-xs font-bold text-slate-500 flex-shrink-0">{item.registered}/{item.capacity}</span>
				{full &&
					<span className="text-3xs font-black uppercase tracking-wider px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 flex-shrink-0">Complet</span>
				}
				{low &&
					<span className="text-3xs font-black uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 flex-shrink-0">À promouvoir</span>
				}
			</div>
		)
	}

	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
					<div className="h-3 bg-slate-200 rounded-full w-1/3 mb-4"></div>
					<div className="h-12 bg-slate-100 rounded-xl mb-2"></div>
					<div className="h-12 bg-slate-100 rounded-xl"></div>
				</div>
			)
		}
		if (this.props.error === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Activités des 7 prochains jours</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						Réessayer
					</button>
				</div>
			)
		}
		const items = this.props.items || []
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
				<div className="flex items-center justify-between px-5 pt-5 pb-3">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Activités des 7 prochains jours</h2>
					<Link to="/animations" className="group flex items-center gap-1 text-2xs font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-800 cursor-pointer transition-colors whitespace-nowrap">
						Planning
						<ChevronRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
					</Link>
				</div>
				{this._renderViews()}
				{items.length === 0 &&
					<div className="flex items-start gap-3 px-5 pb-5">
						<div className="w-9 h-9 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
							<CalendarIcon className="w-5 h-5 text-amber-600" aria-hidden="true" />
						</div>
						<div>
							<p className="text-sm font-bold text-slate-800 my-0">Aucune activité prévue cette semaine.</p>
							<p className="text-xs font-medium text-slate-400 mt-0.5 mb-3">
								{this.props.onsitePeople > 0
									? this.props.onsitePeople + ' personnes sont sur site : une activité annoncée par notification crée de l\'engagement immédiat.'
									: 'Préparez votre programme pour les prochains séjours.'}
							</p>
							<Link
								to="/animations"
								className="inline-flex items-center px-4 py-2.5 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
								style={{ backgroundImage: 'none' }}
							>
								Créer une activité
							</Link>
						</div>
					</div>
				}
				{items.length > 0 &&
					<div>
						{items.slice(0, 6).map(item => {
							return (
								<div key={item.id} className="flex items-center gap-3 px-5 py-3 border-t border-slate-100">
									{this._renderDateBadge(item.start)}
									<div className="flex-1 min-w-0">
										<div className="flex items-center justify-between gap-3">
											<p className="text-sm font-bold text-slate-800 my-0 truncate">{item.title}</p>
											<p className="text-xs font-black text-slate-400 my-0 flex-shrink-0">{this._formatTime(item.start)}</p>
										</div>
										{this._renderGauge(item)}
									</div>
								</div>
							)
						})}
					</div>
				}
				{items.length > 6 &&
					<p className="px-5 py-3 my-0 text-xs font-bold text-slate-400 border-t border-slate-100">+ {items.length - 6} autre{(items.length - 6 > 1) ? 's' : ''} activité{(items.length - 6 > 1) ? 's' : ''} cette semaine</p>
				}
			</div>
		)
	}
}

export default ActivityWeekCard
